// import { Button as ADBUTTON } from "antd"
// import "./Button.scss"

// const Button = ({
//   text,
//   type = "default",
//   className = "",
//   style,
//   id,
//   loading = false,
//   onClick,
//   icon,
//   iconPosition = "left", // "left" or "right"
//   block = false,
//   danger = false,
//   disabled = false,
//   shape = "default", // "default", "circle", "round"
//   color = "primary", // custom usage in className
//   variant = "", // custom usage in className
// }) => {
//   return (
//     <ADBUTTON
//       type={type}
//       className={`button ${color} ${variant} ${className}`}
//       style={style}
//       id={id}
//       loading={loading}
//       onClick={onClick}
//       block={block}
//       danger={danger}
//       disabled={disabled}
//       shape={shape}
//     >
//       {iconPosition === "left" && icon}
//       {text}
//       {iconPosition === "right" && icon}
//     </ADBUTTON>
//   )
// }

// export default Button

// =====================================

import React from "react"
import { Button as AntdButton } from "antd"
import PropTypes from "prop-types"
import "./Button.scss" // optional for your custom styles

const Button = ({
  text,
  icon,
  iconPosition = "left", // 'left' | 'right'
  className = "",
  style = {},
  ...restProps
}) => {
  return (
    <AntdButton
      className={`button ${className}`}
      style={style}
      icon={iconPosition === "left" ? icon : null}
      {...restProps}
    >
      {iconPosition === "right" && icon ? (
        <>
          {text} {icon}
        </>
      ) : (
        text
      )}
    </AntdButton>
  )
}

Button.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  className: PropTypes.string,
  style: PropTypes.object,
}

export default Button
